import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-text-area-historical',
    templateUrl: './text-area-historical.component.html',
    styleUrls: ['./text-area-historical.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaHistoricalComponent implements OnInit {
  @ViewChild('editContent') editContent!: ElementRef<HTMLDivElement>;

  // skipcq: JS-0323
  @Output() readonly onValueChanged = new EventEmitter<any>();
  @Output() readonly valueChange = new EventEmitter<string>();

  @Input() height?: string;
  @Input() maxLength = 500;
  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() hasLabel = false;
  @Input() disabled = false;
  @Input() isMandatory = false;
  @Input() autoResizeEnabled = false;
  @Input() validationRules: any[] = [];
  @Input() originalValue?: string;
  @Input() showCharacterCount = false;

  private _readOnly = false;
  @Input() get readOnly(): boolean {
      return this._readOnly;
  }
  set readOnly(value: boolean) {
      this._readOnly = value;
  }

  private _value!: string;
  @Input() get value() {
      return this._value;
  }

  set value(value: string) {
      if (value === this._value) return;
      this._value = value;

      this.valueChange.emit(value);
  }

  newValue!: string;
  valueCounting = 0;

  observer!: Observable<Event>;
  // skipcq: JS-0323
  textInterval!: any;

  ngOnInit(): void {
    // Validation rules are now handled by parent FormGroup if needed
  }

  // skipcq: JS-0323
  handleValueChanged(event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    this.onValueChanged.emit({ value });
  }

  // skipcq: JS-0323
  handleFocus(sender: any, textarea: HTMLTextAreaElement) {
    textarea.focus();
  }

  // skipcq: JS-0323
  handleKeyUp(event: KeyboardEvent) {
    const text = (event.target as HTMLTextAreaElement).value;
    this.valueCounting = text?.length ?? 0;
  }
}
